import React from 'react';
import { AlertTriangle, Trash2 } from 'lucide-react';
import { Button } from '../../../components/ui/Button';
import { Input } from '../../../components/ui/Input';
import { AdminOrganization, Project } from '../../../types/domain';

interface AdminOrgDangerTabProps {
  organization: AdminOrganization;
  projects: Project[];
  totalDatastores: number;
  totalSubmissions: number;
  orgDeleteInput: string;
  setOrgDeleteInput: (val: string) => void;
  isDeletingOrg: boolean;
  onConfirmDeleteOrg: (e: React.FormEvent) => void;
}

export const AdminOrgDangerTab: React.FC<AdminOrgDangerTabProps> = ({
  organization,
  projects,
  totalDatastores,
  totalSubmissions,
  orgDeleteInput,
  setOrgDeleteInput,
  isDeletingOrg,
  onConfirmDeleteOrg,
}) => {
  return (
    <div className="space-y-4 font-sans text-xs">
      <div className="p-5 rounded-lg bg-rose-500/10 border border-rose-500/30 space-y-4">
        <div className="flex items-start gap-3">
          <AlertTriangle size={20} className="text-rose-500 shrink-0 mt-0.5" />
          <div>
            <h3 className="text-sm font-bold text-rose-500">Permanent Tenant Deletion Zone</h3>
            <p className="text-xs text-rose-600/90 dark:text-rose-400/90 mt-1">
              This action is immediate and completely irreversible. All {projects.length} projects,{' '}
              {totalDatastores} datastores, {totalSubmissions} submissions, and all files stored in S3 or local
              storage will be permanently destroyed. Orphaned test users who belong solely to this organization
              will also be automatically pruned from the platform.
            </p>
          </div>
        </div>

        <form onSubmit={onConfirmDeleteOrg} className="pt-2 space-y-3 max-w-md">
          <div>
            <label className="block text-cf-textSecondary mb-1.5 text-xs">
              To confirm permanent deletion, type the organization slug{' '}
              <strong className="text-cf-textPrimary font-sans select-all bg-cf-bg px-1.5 py-0.5 rounded border border-cf-border">
                {organization.slug}
              </strong>
              :
            </label>
            <Input
              type="text"
              size="sm"
              value={orgDeleteInput}
              onChange={(e) => setOrgDeleteInput(e.target.value)}
              placeholder={organization.slug}
            />
          </div>

          <Button
            type="submit"
            variant="danger"
            size="sm"
            disabled={orgDeleteInput.trim() !== organization.slug || isDeletingOrg}
            loading={isDeletingOrg}
            icon={<Trash2 size={14} />}
          >
            Permanently Purge Organization & Wipe Storage
          </Button>
        </form>
      </div>
    </div>
  );
};
